export const ADD_ADDRESS_REQUEST = 'add/address/request'
export const ADD_ADDRESS_SUCCESS = 'add/address/success'
export const ADD_ADDRESS_ERROR = 'add/address/error'